import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';

import './Dropdown.scss';

import { defaultTextColor } from '../../../Utils/CommonFunctions';

export default function Dropdown(props) {
  const { isOpenDrawer = false, setIsOpenDrawer = () => {}, dropDownHeader = () => {}, dropdownBody = () => {}, 
  isShowIcon = false, isHeader = false, onClose = () => {} } = props;
  const queryClient = useQueryClient();
  const integratorTheme = queryClient.getQueryData(['integrator-theme', true]) || {};
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    if (isOpenDrawer) {
      onClose();
    }
    setIsOpenDrawer(!isOpenDrawer);
  };

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpenDrawer(false);
      onClose();
    }
  }, [onClose, setIsOpenDrawer]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <div ref={dropdownRef} className={`dropdownWrapper ${isHeader ? 'header' : ''}`}>
      <div className="dropdownHeader" onClick={toggleDropdown}>
        {typeof(dropDownHeader) === 'function' ? dropDownHeader(): dropDownHeader}
        {isShowIcon && (
          isOpenDrawer ? <ChevronUp color={defaultTextColor(integratorTheme)} size={20} /> : <ChevronDown color={defaultTextColor(integratorTheme)} size={20} />
        )}
      </div>

      {isOpenDrawer && (
        <div className="dropdownMenu" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
          <div role="none">{typeof(dropdownBody) === 'function' ? dropdownBody() : dropdownBody}</div>
        </div>
      )}
    </div>
  );
}

Dropdown.propTypes = {
  isOpenDrawer: PropTypes.bool.isRequired,
  setIsOpenDrawer: PropTypes.func.isRequired,
  dropDownHeader: PropTypes.func.isRequired,
  dropdownBody: PropTypes.func.isRequired,
  isShowIcon: PropTypes.bool,
  isHeader: PropTypes.bool,
  onClose: PropTypes.func,
};
